import { Id, UsersResponse } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from '../../shared/queries/keys'
import { convertManagersList } from './shared/convert'
import { ComposeUser } from './shared/types'

export function useManagersList(storeId: Id | undefined) {
  const { server } = useServer()
  return useQuery<Array<ComposeUser>>({
    queryKey: storeId ? keys.managersList(storeId) : [],
    queryFn: fetchManagers,
    enabled: !!storeId,
  })

  async function fetchManagers() {
    if (!storeId) {
      throw new Error('Illegal store ID')
    }

    const response = await server.get<UsersResponse.User[]>(
      `/v2/helpers/me/stores/${storeId}/managers`
    )

    return convertManagersList(response)
  }
}
